import { FeatureMiddleware } from '../featureInterface';
import { createFeatureDestinationHomeMiddleware } from './home';

export function createFeatureDestinationMiddleware(): FeatureMiddleware[] {
    return [createFeatureDestinationHomeMiddleware()];
}
